import React from "react";

export default function DocumentSignatureSignedIcon() {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="21"
        viewBox="0 0 16 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 12L7 14L11.5 9.5M13 19.5H3C1.89543 19.5 1 18.6046 1 17.5V3.5C1 2.39543 1.89543 1.5 3 1.5H10.1716C10.702 1.5 11.2107 1.71071 11.5858 2.08579L14.4142 4.91421C14.7893 5.28929 15 5.79799 15 6.32843V17.5C15 18.6046 14.1046 19.5 13 19.5Z"
          stroke="#35C379"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </React.Fragment>
  );
}
